import * as DOMPurify from 'dompurify';

export function sanitizeHtml(htmlStr: string) {
    return DOMPurify.sanitize(htmlStr, { ALLOWED_TAGS: ['span', 'b', 'em'], ALLOWED_ATTR: ['class'] });
}